<template>
    <div class="index618">
      <img src="../assets/img/img1-618.png" alt="" />
      <img src="../assets/img/img2-618.png" alt="" />
      <img src="../assets/img/img3-618.png" alt="" />
      <img src="../assets/img/img4-618.png" alt="" />
      <img src="../assets/img/img5-618.png" alt="" />
      <img src="../assets/img/img6-618.png" alt="" />
      <img src="../assets/img/img7-618.png" alt="" />
      <img src="../assets/img/img8-618.png" alt="" />
    </div>
</template>

<script>
export default {
    name: "",
    components: {},
    props:{},
    data() {
        return {}
    },
    created(){},
    mounted(){},
    methods: {}
}
</script>

<style lang="scss" scoped>
.index618{
  img{
    display:block;
    max-width:750px;
    width:100%;
  }
}
</style>
